<template>
  <div class="step-container">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-container">
          <h6>{{ currentStep.title }}</h6>
        </div>
        <career-progression-table />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 button-group">
        <button type="button" class="btn btn-lg btn-default" @click="setPreviousStep">
          <i class="fa fa-caret-left" />
          Previous
        </button>
        <button type="button" class="btn btn-lg btn-primary" @click="setNextStep"
          :disabled="dutyDaysHasError">
          Continue
          <i class="fa fa-caret-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CareerProgressionMixin from '@/js/mixins/calculator/career-progression-mixin';
import CareerProgressionTable from './career-progression-table';

export default {
  mixins: [CareerProgressionMixin],

  components: {
    'career-progression-table': CareerProgressionTable,
  },
};
</script>

<style scoped lang="scss">
@import '~@/styles/resources';

.step-container {
  background-color: $wizard-step-bg;
}
</style>
